var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0941 11.6535C20.4114 11.3362 20.9259 11.3362 21.2432 11.6535C21.5605 11.9708 21.5605 12.4852 21.2432 12.8025L13.7763 20.2694C11.5541 22.4916 7.95129 22.4916 5.72913 20.2694C3.50696 18.0472 3.50696 14.4444 5.72913 12.2222L13.196 4.75535C14.7832 3.16814 17.3566 3.16814 18.9438 4.75535C20.531 6.34256 20.531 8.91594 18.9435 10.5035L11.4688 17.97C10.5165 18.9223 8.97263 18.9223 8.02038 17.97C7.06812 17.0178 7.06812 15.4739 8.02072 14.5213L14.9188 7.63126C15.2363 7.31415 15.7508 7.31445 16.0679 7.63194C16.385 7.94943 16.3847 8.46388 16.0672 8.78099L9.16943 15.6707C8.85177 15.9883 8.85177 16.5033 9.16943 16.821C9.48708 17.1386 10.0021 17.1386 10.3201 16.8207L17.7948 9.3541C18.7474 8.40149 18.7474 6.85701 17.7948 5.9044C16.8421 4.95179 15.2977 4.95179 14.3451 5.9044L6.87817 13.3713C5.29061 14.9588 5.29061 17.5328 6.87817 19.1204C8.46574 20.7079 11.0397 20.7079 12.6273 19.1204L20.0941 11.6535Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.9c7a6a0ad3b6d6305e2458349124d829.svg";
export { ForwardRef as ReactComponent };